import React from "react";
import Synonyms from "./Synonyms";
import Antonyms from "./Antonyms";
import Example from "./Example";
import "./Meaning.css";

export default function Meaning(props) {
  return (
    <div className="Meaning">
      <h3>{props.meaning.partOfSpeech}</h3>
      {props.meaning.definitions.map(function (definition, index) {
        return (
          <div key={index}>
            <div>
              <span className="definition">
                <strong>{index + 1}. </strong>
              </span>
              {definition.definition}
            </div>
            <Example example={definition.example} />
            <br />
          </div>
        );
      })}
      <Synonyms synonyms={props.meaning.synonyms} />
      <Antonyms antonyms={props.meaning.antonyms} />
    </div>
  );
}
